'use strict';

const Backbone = require('backbone/backbone');
const _ = require('underscore');

require('./Page.less');

module.exports = Backbone.View.extend({

    el: 'body',

    initialize: function () {
        _.bindAll(this,
            'onScroll',
            'onResize',
            'scrollToHash',
            'toggleMobileMenu',
            'onAnchorLinkClick',
            'disableScroll',
            'enableScroll');

        this.isMobileMenuOpened = false;
        this.savedScroll = 0;

        this.initAnimatedBlocks();
        this.initAnchors();
        this.onScroll._throttled = _.throttle(this.onScroll, 50);
        this.onResize._throttled = _.throttle(this.onResize, 50);
        window.addEventListener('scroll', this.onScroll._throttled);
        window.addEventListener('resize', this.onResize._throttled);
        this.scrollToHash();
        this.$('.PageIndex-burger').on('click', () => {
            this.toggleMobileMenu();
        });
        this.onResize();
    },

    _initChildViews(views) {
        if (!this.childViews) {
            this.childViews = {};
        }
        for (let i = 0; i < views.length; i++) {
            this.childViews[views[i].name] = new views[i].Constructor({page: this});
        }
    },

    scrollToHash() {
        const hash = Backbone.history.getHash();

        if (!hash) {
            return;
        }

        const scrollTo = this.$(`[data-id=${hash}`).offset().top;
        const $window = $(window);

        if (scrollTo === $window.scrollTop) {
            return;
        }

        this.isScrollToBlockInProgress = true;

        $('html, body').animate({ scrollTop: scrollTo }, 500, () => {
            this.isScrollToBlockInProgress = false;
        });
    },

    initAnchors() {
        this.anchorElements = this.$('[data-id]');
        this.anchorLinks = this.$('.PageIndex-left a');
        this.anchorLinksMobile = this.$('.PageIndex-menuMobile a');

        $(this.anchorLinks).on('click', (event) => {
            this.onAnchorLinkClick(event);
        });

        $(this.anchorLinksMobile).on('click', (event) => {
            this.toggleMobileMenu();
            this.onAnchorLinkClick(event);
        });
    },

    onAnchorLinkClick(event) {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        const $target = $(event.target).closest('a');
        const href =  $target
            .attr('href')
            .replace('#', '');
        $(this.anchorLinks).removeClass('isActive');
        $target.addClass('isActive');

        const scrollTo = this.$(`[data-id=${href}`).offset().top;
        this.isScrollToBlockInProgress = true;

        const scrollTime = isMobile ? 200 : 500;
        $('html, body').animate({ scrollTop: scrollTo }, scrollTime, () => {
            this.isScrollToBlockInProgress = false;
        });
    },

    toggleMobileMenu() {
        this.isMobileMenuOpened = !this.isMobileMenuOpened;
        if (this.isMobileMenuOpened) {
            this.disableScroll();
        } else {
            this.enableScroll();
        }
        this.$('.PageIndex-burger').toggleClass('isOpened');
        this.$('.PageIndex-menuMobile').toggleClass('isOpened');
        window.document.documentElement.classList.toggle('hasActiveModals');
    },

    disableScroll() {
        this.savedScroll = window.scrollY;
        const bodyHtml = document.querySelector('body, html');
        bodyHtml.style.overflow = 'hidden';
        bodyHtml.style.position = 'fixed';
        bodyHtml.style.top = `-${this.savedScroll}px`;
        bodyHtml.style.width = '100%';
    },

    enableScroll() {
        const bodyHtml = document.querySelector('body, html');
        bodyHtml.style.removeProperty('overflow');
        bodyHtml.style.removeProperty('position');
        bodyHtml.style.removeProperty('top');
        bodyHtml.style.removeProperty('width');
        window.scrollTo(0, this.savedScroll);
    },

    stopPropagationOnMobileMenuTouchMove(event) {
        event.preventDefault();
    },

    initAnimatedBlocks() {
        this.animatedBlocks = this.$('[data-show-animation-state="0"]');
    },

    onResize() {
        this.onScroll();
    },

    onScroll() {
        const scrollTop = $(window)
            .scrollTop();
        const wh = $(window)
            .height();

        const burgerTopAppear = $(this.anchorElements[0]).offset().top - 50;
        $('.PageIndex-burger').toggleClass('isActive', scrollTop > burgerTopAppear);

        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        const offset = isMobile ? 70 : 150;
        const topPosition = scrollTop + wh - offset;

        _.each(this.animatedBlocks, function (block) {
            if (!block.isAnimated) {
                if (topPosition >= $(block).offset().top) {
                    block.removeAttribute('data-show-animation-state');
                    block.isAnimated = true;
                }
            }
        }.bind(this));

        if (this.isScrollToBlockInProgress) {
            return;
        }

        let $lastBlock;
        _.each(this.anchorElements, function (anchorBlock) {
            let $anchorBlock = $(anchorBlock);
            if (topPosition >= $anchorBlock.offset().top) {
                $lastBlock = $anchorBlock;
            }
        }.bind(this));

        if (!$lastBlock) {
            return;
        }

        if ($lastBlock && $lastBlock.hasClass('isActive')) {
            return;
        }

        $(this.anchorElements).removeClass('isActive');
        const anchorLinks = [...this.anchorLinks, ...this.anchorLinksMobile];
        $(anchorLinks).removeClass('isActive');
        const dataId = $lastBlock.attr('data-id');
        _.each(anchorLinks, function (anchorLink) {
            const $anchorLink = $(anchorLink);
            const href = ($anchorLink.attr('href') || '').replace('#', '');

            if (href === dataId) {
                $anchorLink.addClass('isActive');
            }
        }.bind(this));
        $lastBlock.addClass('isActive');
    }
});
